export enum CustomerFormContext {
    KeyInfo = 'KeyInfo',
    ProfileInfo = 'ProfileInfo'
}